import {getRecommendationName} from '../CreateRecommend/RecommendSourceDestination/naming';
import {
  nonEmptyStringOrNull,
  updateRecommendPotsVariables,
  updateRecsVarsProps,
} from './helpers';
import {UpsertOvrecommendVariables} from '../../../schema-types/UpsertOvrecommend';
import {
  SPP_RECOMMENDATION_TYPES,
  recommendationFormToServerType,
} from '../../../constants/SolutionType';
import {cleanForCuro} from '../../../utils/cleanString';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';
import getWithdrawalVariables, {
  generateWithdrawalOVRPots,
} from './getWithdrawalVariables';
import getContributionVariables, {
  generateContributionOVRPots,
} from './getContributionVariables';
import getTransferVariables, {generateTransferOVRPots} from './getTransferVariables';
import getNewVariables, {generateNewOVRPots} from './getNewVariables';
import getProtectionVariables, {
  generateProtectionOVRPots,
} from './getProtectionVariables';
import getAnnuityVariables, {generateAnnuityOVRPots} from './getAnnuityVariables';
import {generateActionOVRPots, getActionVariables} from './getActionVariables';
import {generateModifyOVRPots, getModifyVariables} from './getModifyVariables';
import saltus from '../../../shared/logger';
import getAdHocFeeVariables, {generateAdHocFeeOVRPots} from './getAdHocFeeVariables';
import validateUUID from '../../../utils/validateUUID';

export interface getUpdateVariablesPayloadType {
  variables?: UpsertOvrecommendVariables;
  error?: Error;
}

export const getUpdateVariables = async (props: updateRecsVarsProps) => {
  const {values} = props;

  switch (values?.planAction) {
    case OVRecommendActionEnum.WITHDRAW:
      return getWithdrawalVariables(props);
    case OVRecommendActionEnum.CONTRIBUTE:
      return getContributionVariables(props);
    case OVRecommendActionEnum.TRANSFER:
      return getTransferVariables(props);
    case OVRecommendActionEnum.SET_UP_NEW:
      if (values.mainPlanType === 'protectionPlan') {
        return getProtectionVariables(props);
      }
      if (values.mainPlanType === 'annuity') {
        return getAnnuityVariables(props);
      }
      return getNewVariables(props);
    case OVRecommendActionEnum.ACTION:
      return getActionVariables(props);
    case OVRecommendActionEnum.MODIFY:
      return getModifyVariables(props);
    case OVRecommendActionEnum.AD_HOC_FEE:
      return getAdHocFeeVariables(props);
    default:
      throw Error('selected plan action not valid');
  }
};

export const updateRecommendPots = async (props: updateRecommendPotsVariables) => {
  const {values} = props;

  switch (values?.planAction) {
    case OVRecommendActionEnum.WITHDRAW:
      return generateWithdrawalOVRPots(props);
    case OVRecommendActionEnum.CONTRIBUTE:
      return generateContributionOVRPots(props);
    case OVRecommendActionEnum.TRANSFER:
      return generateTransferOVRPots(props);
    case OVRecommendActionEnum.SET_UP_NEW:
      if (values.mainPlanType === 'protectionPlan') {
        return generateProtectionOVRPots(props);
      }
      if (values.mainPlanType === 'annuity') {
        return generateAnnuityOVRPots(props);
      }
      return generateNewOVRPots(props);
    case OVRecommendActionEnum.ACTION:
      return generateActionOVRPots(props);
    case OVRecommendActionEnum.MODIFY:
      return generateModifyOVRPots(props);
    case OVRecommendActionEnum.AD_HOC_FEE:
      return generateAdHocFeeOVRPots(props);
    default:
      throw Error('selected plan action not valid');
  }
};
type id = string;
const updateRec = async (
  updateRecProps: updateRecsVarsProps,
  adviceWhat: string,
  advicePlan: string
): Promise<id> => {
  const {
    ovrecommendId: existingOvrecommendId,
    values,
    contactName,
    upsertRecommendation,
    reviewId,
  } = updateRecProps;
  const specificVariables = await getUpdateVariables(updateRecProps);
  const variables: UpsertOvrecommendVariables = {
    note: cleanForCuro(values?.note), // note has to be before
    ...specificVariables,
    ovrecommendId: validateUUID(existingOvrecommendId),
    solutionType: recommendationFormToServerType(values),
    reviewId: validateUUID(reviewId),
    name: getRecommendationName(values, contactName || ''),
    planType: values?.mainPlanType,
    isXo: values?.how === 'Instruction',
    isSppDaXo: values.sppType === SPP_RECOMMENDATION_TYPES.ExecutionOnly,
    isDependantsPension: values.transfer?.isDependantsPension,
    isAps: values.transfer?.isAps,
    isPensionSharing: values.transfer?.isPensionSharing,
  };
  // debugger;
  Object.keys(variables).forEach((key) => {
    (variables as any)[key] = nonEmptyStringOrNull((variables as any)[key]);
  });
  // debugger;
  const {data} = await upsertRecommendation({
    variables,
  });
  if (data?.upsertOvrecommend?.ovrecommend) {
    const ovrecommendId = data.upsertOvrecommend.ovrecommend.id;
    saltus.log({recommends: data?.upsertOvrecommend?.ovrecommend.recommends});
    await updateRecommendPots({
      ...updateRecProps,
      ovrecommendId: validateUUID(ovrecommendId)!,
    });
    return ovrecommendId;
  }
  throw Error(`Could not create. Error: ${data?.upsertOvrecommend?.errors?.join('.')}`);
};

export default updateRec;
